import { router } from 'expo-router'
import { useEffect } from 'react'
import { View } from 'react-native'

import { Typography } from '@/src/elements/text/Typography'
import { INTENTION_TYPE } from '@/src/features/intention/models/Intention.enums'
import { useIntentionQuery } from '@/src/features/intention/services/useIntentionQuery'
import { TEST_ID } from '@/src/general/constants/testId'
import { useRoutes } from '@/src/general/utils/routes'
import { useTranslate } from '@/src/lang/useTranslate'

import { IntentionCard } from '../../../components/IntentionCard'
import type { TIntentionPrayersScreenProps } from '../IntentionPrayersScreen'
import { HeaderPlaceholder } from './HeaderPlaceholder'

type TListHeaderProps = { isIntentionPrayersPending: boolean; isError: boolean } & TIntentionPrayersScreenProps

export const ListHeaderComponent = ({ type, isIntentionPrayersPending, intentionId, isError }: TListHeaderProps) => {
  const { t } = useTranslate()
  const { routes } = useRoutes()
  const { intention, isPending: isIntentionPending } = useIntentionQuery(intentionId, undefined, type)

  useEffect(() => {
    if (!isIntentionPrayersPending && !isIntentionPending && isError) {
      router.navigate(routes.intentions())
    }
  }, [intentionId, isError, isIntentionPending, isIntentionPrayersPending, routes])

  return (
    <>
      {!isIntentionPending && (
        <View className="flex w-full flex-col gap-8 pb-5">
          {intention && intention.type === INTENTION_TYPE.INTENTION && (
            <IntentionCard
              type={INTENTION_TYPE.INTENTION}
              intention={intention}
              color="primary"
              className="bg-white"
              classNames={{ text: 'font-bold' }}
            />
          )}
          <Typography contrast="high" className="px-4">
            {t('intention.finished.prayers', {
              type: type satisfies 'intention' | 'arrival' | 'birthday',
              count: intention?.prayersCount,
            })}
          </Typography>
        </View>
      )}
      {!!isIntentionPending && <HeaderPlaceholder testID={TEST_ID.INTENTIONS.CARD.LOADING} />}
    </>
  )
}
